import React, { useContext, useMemo } from 'react'
import { LeagueContext } from '../../../../Context'
import { AdditionalHeadlines } from '../../../../Components/Feed/Articles/AdditionalHeadlines'

export const MoreTrending: React.FC<React.PropsWithChildren<unknown>> = () => {
  const context = useContext(LeagueContext)
  if (!context) {
    throw new Error(
      'MoreTrending headlines must be used within a LeagueContext provider'
    )
  }
  const { homeFeed } = context

  const moreTrendingItems = useMemo(() => {
    if (homeFeed?.trending?.feedItems && homeFeed.trending.feedItems.length > 1) {
      return homeFeed.trending.feedItems.slice(1)
    }
    return []
  }, [homeFeed])

  return (
    <>
      {moreTrendingItems.length > 0 && (
        <AdditionalHeadlines feedItems={moreTrendingItems} />
      )}
    </>
  )
}
